import Notifiq from "@/Pages/Notifiq/index.vue";
import { can } from "@/plugins/can";
import IndexNotifiq from "@/Pages/Notifiq/IndexNotifiq.vue";

const checkPermission = (permissions) => {
  return (to, from, next) => {
    if (!can(permissions)) {
      return next({ name: "NaoAutorizado" });
    }
    return next();
  };
};

export default [
  {
    path: "/notifiq/index",
    name: "notifiq.index",
    component: Notifiq,
    beforeEnter: checkPermission(["notifiq.load"]),
  },
  {
    path: "/notifiq/presencas",
    name: "notifiq.indexNotifiq",
    title: "Presença Notifiq",
    component: IndexNotifiq,
  },
];
